import { useCallback, useEffect, useRef, useState } from 'react';
import Sheet from 'components/Overlays/AnimatedSheet';
import { FiMenu, FiX } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';
import PortalSidebar from './PortalSidebar';
import useNavigationDrawer from './useNavigationDrawer';

export default function MobileMenu() {
    const [open, setOpen] = useState(false);
    const drawerRef = useRef(null);
    const triggerRef = useRef(null);
    const location = useLocation();
    const close = useCallback(() => setOpen(false), []);
    useEffect(() => { close(); }, [location.pathname, location.search, close]);
    useNavigationDrawer(open, close, drawerRef, triggerRef);
    return <>
        <button type="button" className="portal-menu-trigger" ref={triggerRef} aria-label="Open navigation menu"
            aria-expanded={open} aria-haspopup="dialog" aria-controls={open ? 'portal-mobile-navigation' : undefined}
            onClick={() => setOpen(true)}><FiMenu aria-hidden="true" /><span>Menu</span></button>
        <Sheet visible={open} onHide={close} position="left" blockScroll showCloseIcon={false} closeOnEscape={false} className="portal-navigation-sheet" onShow={() => drawerRef.current?.querySelector('button')?.focus()}>
            <div className="portal-drawer" id="portal-mobile-navigation" role="dialog" aria-modal="true" aria-label="Navigation menu" ref={drawerRef}>
                <PortalSidebar mobile onNavigate={close} closeButton={<button type="button" className="portal-drawer-close" aria-label="Close navigation menu" onClick={close}><FiX aria-hidden="true" /></button>} />
            </div>
        </Sheet>
    </>;
}
